


export class QueryParams {


  private _params: Record<string,any> = {};


  constructor(...params: Record<string,any>[]) {
    if (params) {
      params.forEach(p => {
        Object.assign(this._params, p);
      });
    }
  }


  get queryParams() {
    return this._params;
  }

  addParams(param: Record<string,any>): void {
    Object.assign(this._params, param);
  }

  get params() {
    return this._params;
  }


}
